export default __webpack_public_path__ + "images/59404f3a1048f867fe815dc44c99df9c-iconos_instagram.svg";